/* eslint-disable */
import { produce } from "immer";
import {
  FUND_HISTORY_FETCH_START,
  FUND_HISTORY_FETCH_SUCCESS,
  FUND_HISTORY_FETCH_FAILURE,
} from "../actions/types";

const fundHistory = (
  state = {
    fetching: false,
    data: [],
    error: null,
  },
  action,
) => {
  switch (action.type) {
    case FUND_HISTORY_FETCH_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case FUND_HISTORY_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data;
        draft.fetching = false;
      });
    case FUND_HISTORY_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default fundHistory;
